import { ThreeApp } from '@/Engine/ThreeApp';
import { app } from '@/Engine/app';
import { engineConfig } from '@/Constants/3dConfig';
import { calculateAppWideProgress } from '@/utils/calculateAppWideProgress';
import { EventBus } from '@/utils/eventBus';

export default async function() {
    const CONTAINER_ID = 'v3d-container';
    
    const appInstance = new ThreeApp(CONTAINER_ID, {
        alpha: engineConfig.useBkgTransp,
        preserveDrawingBuffer: engineConfig.preserveDrawBuf,
    });

    // Настройка прогресс-бара
    const onProgress = (percentage) => {
        EventBus.emit('update-progress', calculateAppWideProgress('#process1#', percentage));
    };

    // Загрузка основной сцены
    // await new Promise((resolve) => {
    //     appInstance.loadScene(engineConfig.sceneURL, (scene) => {
    //         resolve(scene);
    //     }, onProgress);
    // });

    appInstance.renderer.setPixelRatio(
        window.devicePixelRatio > 1 ? window.devicePixelRatio : engineConfig.pixelRatio,
    );
    
    appInstance.onResize();
    appInstance.controls.enablePan = engineConfig.enablePan;
    appInstance.controls.enableZoom = engineConfig.enableZoom;
    appInstance.controls.enableKeys = engineConfig.enableKeys;
    
    appInstance.run();

    await app(appInstance);
}
